import { render, staticRenderFns } from "./PopularProducts.vue?vue&type=template&id=0fd95978&scoped=true"
import script from "./PopularProducts.vue?vue&type=script&lang=js"
export * from "./PopularProducts.vue?vue&type=script&lang=js"
import style0 from "./PopularProducts.vue?vue&type=style&index=0&id=0fd95978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd95978",
  null
  
)

export default component.exports